export default ({
    answers,
    part,
    section,
    repeater,
    dependData,
    repeaterId,
}) => {
    // check if there already is an answer for the current question
    let answer = null;
    if (answers[part.slug] && typeof answers[part.slug][section.slug] !== 'undefined') {
        if (repeater) {
            const id = dependData[+repeaterId].name;
            answer = answers[part.slug][section.slug][id];
        } else {
            answer = answers[part.slug][section.slug];
        }
    }

    return answer;
};



// WEBPACK FOOTER //
// ./src/utils/getPreviousAnswers.js